// extracted by mini-css-extract-plugin
export var chevronIcon = "_b1-2";
export var teamName = "_b1-1";
export var teamSwitcherButton = "_b1-0";